/**
 * Multi level filter.
 */
export function filterDropdown() {
	const filter = document.querySelector( '.filter' );
	if ( !filter ) {
		return;
	}

	const $document = $( document );
	const $filterMask = $( '.m__dashboard-filter-mask' );
	const $filter = $( filter );
	const $filterTrigger = $filter.find( '.filter-item-main' );
	const $filterSubmenu = $filter.find( '.filter-submenu-container' );
	const $filterSubmenusItems = $filter.find( '.filter-submenu-item' );
	const $filterRightSubmenus = $filter.find( '.filter-submenu-right' );
	const $filterRightSubmenuItems = $filter.find( '.filter-submenu-right-item' );

	// Open submenu level 1.
	$filterTrigger.on( 'click', () => {
		$filterSubmenu.toggleClass( 'active' );
		$filterMask.show();

		// Hides the menu when clicking outside the menu.
		$document.on( 'mouseup.hideMenuClick', function onClickOutsideMenu( event ) {
			// if the target of the click isn't the container nor a descendant of the container.
			if ( !$filterSubmenu.is( event.target ) && $filterSubmenu.has( event.target ).length === 0 ) {
				$filterSubmenu.removeClass( 'active' );
				$filterMask.hide();
				$document.off( '.hideMenuClick' );
			}
		});

		// Hides the menu when pressing the Escape key.
		$document.on( 'keyup.hideMenuKey', function onPressEscapeKey( event ) {
			if ( event.keyCode === 27 ) {
				$filterSubmenu.removeClass( 'active' );
				$filterMask.hide();
				$document.off( '.hideMenuKey' );
			}
		});
	});

	// Open submenu level 2.
	$filterSubmenusItems.mouseenter( function activateRightSubmenu() {
		$filterSubmenusItems.removeClass( 'active' );
		$filterRightSubmenus.removeClass( 'active' );
		const $this = $( this );
		const $currentItem = $this.siblings( '.filter-submenu-item' );
		const $rightSubmenu = $this.siblings( '.filter-submenu-right' );
		$rightSubmenu.toggleClass( 'active' );
		$currentItem.toggleClass( 'active' );
	});

	// Click on submenu level 2 items.
	$filterRightSubmenuItems.on( 'click', function selectFilter() {
		$filterSubmenu.toggleClass( 'active' );
		$filterMask.hide();
		$filterSubmenusItems.removeClass( 'active' );
		$filterRightSubmenus.removeClass( 'active' );
		$filterTrigger.html( $( this ).html() );
	});
}